import {lazy, Suspense} from 'react';
import {Link} from 'react-router-dom';
import cx from 'classnames';

import styles from './StartVerifying.module.scss';
import Section from '../Section';
import SectionContents from '../SectionContents';
import SectionContentsBody from '../SectionContentsBody';
import SectionContentsCta from '../SectionContentsCta';

const StartPlayer = lazy(() => import('./StartPlayer'));

function Index() {
  return (
    <Section padded light>
      <SectionContents sizes={{xs: [12, 12], lg: [6, 6]}}>
        <div
          className={cx(
            styles['section--container'],
            'text-md-left text-center'
          )}
        >
          <SectionContentsBody
            title="Start Verifying with Confidence"
            description="Access trusted certification data, check ISO certification online, monitor supplier compliance, and simplify due diligence to save time, lower costs, and protect against risk."
          />
          <div className="mt-3">
            <SectionContentsCta tag={Link} to="/register/user">
              Get Started for FREE
            </SectionContentsCta>
          </div>
        </div>
        <Suspense fallback={null}>
          <StartPlayer />
        </Suspense>
      </SectionContents>
    </Section>
  );
}

export default Index;
